var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about"},[_c('h1',[_vm._v("Exchange Token")]),_c('p',[_vm._v(_vm._s(_vm.error))])])
}
var staticRenderFns = []

export { render, staticRenderFns }